﻿import { autorun, makeObservable, observable } from "mobx";
import { IChartWmsState } from "../models/ChartModels";
import { IStateStore, StateStore } from "./StateStore";

export class ChartWmsStore extends StateStore<IChartWmsState> implements IChartWmsState, IStateStore<IChartWmsState> {

    showCustomDepthContours: boolean = false;
    useCustomDepthContours: boolean = false;
    shallowContour: number = 0;
    deepContour: number = 100;       
    safetyDepth: number = 5;
    safetyDepthIsCalculated: boolean = false;
    keelClearanceIsRelative: boolean = false;
    keelClearance: number = 0;
    shipDraught: number = 5;
    tide: number = 0; 

    showCustomDepthContourInterval: boolean = false;
    useCustomDepthContourInterval: boolean = false;    
    depthContourInterval: number = 0.1;  

    constructor() {
        super()
        makeObservable(this, {
            showCustomDepthContours: observable,           
            useCustomDepthContours: observable,              
            shallowContour: observable,
            deepContour: observable,            
            safetyDepth: observable,
            safetyDepthIsCalculated: observable,
            keelClearanceIsRelative: observable,
            keelClearance: observable,            
            shipDraught: observable,
            tide: observable,
            showCustomDepthContourInterval: observable,
            useCustomDepthContourInterval: observable,
            depthContourInterval: observable,
        });

        autorun(() => {
            if (this.safetyDepthIsCalculated) {
                var safetyDepth: number
                if (this.keelClearanceIsRelative)
                    safetyDepth = this.shipDraught * (1.0 + 0.01 * this.keelClearance) - this.tide;
                else
                    safetyDepth = this.shipDraught + this.keelClearance - this.tide;

                this.setState({ safetyDepth });
            }         
        })
    }      

    public get getState(): IChartWmsState {
        const {
            useCustomDepthContours, shallowContour, deepContour, useCustomDepthContourInterval, depthContourInterval, showCustomDepthContourInterval,
            keelClearanceIsRelative, keelClearance, shipDraught, tide, safetyDepthIsCalculated, safetyDepth, showCustomDepthContours
        } = this;

        return {
            useCustomDepthContours, shallowContour, deepContour, useCustomDepthContourInterval, depthContourInterval, showCustomDepthContourInterval,
            keelClearanceIsRelative, keelClearance, shipDraught, tide, safetyDepthIsCalculated, safetyDepth, showCustomDepthContours
        };
    }   
}